export const resolveCardTitle = (
  explicit: string | undefined,
  fallback: string,
): string => {
  const normalized = (explicit ?? '').toString().trim();
  return normalized.length > 0 ? normalized : fallback;
};

export const resolveCardLabel = (
  explicit: string | undefined,
  fallback: string,
): string => {
  const normalized = (explicit ?? '').toString().trim();
  return normalized.length > 0 ? normalized : fallback;
};

export const resolveCardColspan = (
  explicit: number | undefined,
  fallback: number,
): number => {
  if (typeof explicit === 'number' && Number.isFinite(explicit) && explicit > 0) {
    return explicit;
  }
  return fallback;
};
